module.exports = __webpack_public_path__ + "static/media/test10_3.1ca42b20.png";